import { render } from "./admin-ctrl.vue?vue&type=template&id=96db4634&scoped=true"
import script from "./admin-ctrl.vue?vue&type=script&lang=js"
export * from "./admin-ctrl.vue?vue&type=script&lang=js"

import "./admin-ctrl.vue?vue&type=style&index=0&id=96db4634&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96db4634"]])

export default __exports__